exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".special-offer--first[data-v-4907f4f8] {\n  position: relative;\n}\n.special-offer--first[data-v-4907f4f8]:after {\n  display: inline-block;\n  position: absolute;\n  color: #ffffff;\n  right: 0;\n  font-size: 1.125rem;\n  line-height: 1.75rem;\n  top: 50%;\n  content: '+';\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n", ""]);

// exports
